
import store from '../store'
import { environments } from '../../common/environment-configs'
import { getUserCredentials } from './authentication-utils'
import axios from 'axios'

// Fixme user details must be specified by the user
export const getCredentials = () => {
  if (store.getState().environment.value === environments.LOCAL) {
    return {
      username: 'admin',
      password: 'admin'
    }
  }
  return getUserCredentials()
}

export const GET = (target) => (
  axios.get(target,
    {
      auth: getCredentials()
    })
)

export const PUT = (target, configurations) => (
  axios.put(target, configurations,
    {
      auth: getCredentials()
    }
  )
)

export const DELETE = (target) => (
  axios.delete(target,
    {
      auth: getCredentials()
    }
  )
)
